export default "__VITE_ASSET__DtQHlZm6__"